import { extend, override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import EngineVersionDropdown from './components/EngineVersionDropdown';
import EngineVersion from '../common/models/EngineVersion';

export default function addEngineVersionComposer() {
  // Add engine version dropdown to composer header
  extend(DiscussionComposer.prototype, 'headerItems', function (items) {
    const self = this;
    const selectedVersion = self.composer.fields.engineVersion as EngineVersion | null;

    items.add(
      'engineVersion',
      m(EngineVersionDropdown, {
        selectedVersion: selectedVersion,
        onselect: (version: EngineVersion) => {
          self.composer.fields.engineVersion = version;
          self.composer.fields.engineVersionId = version ? version.id() : null;
          m.redraw();
        },
      }),
      5
    );
  });

  // Include engine version in the data sent to the server
  // data() 返回一个对象，extend 的回调第一个参数是原方法的返回值
  extend(DiscussionComposer.prototype, 'data', function (data) {
    // 从 composer.fields 获取引擎版本
    const engineVersion = this.composer.fields.engineVersion as EngineVersion | null;
    const engineVersionId = engineVersion ? engineVersion.id() : this.composer.fields.engineVersionId;

    // 调试日志
    console.log('EngineVersion data:', { engineVersion, engineVersionId, fields: this.composer.fields });

    if (engineVersionId) {
      data.engineVersionId = engineVersionId;
    }

    return data;
  });

  // Validate before submit
  override(DiscussionComposer.prototype, 'onsubmit', function (original) {
    // 从 composer.fields 获取引擎版本
    const engineVersion = this.composer.fields.engineVersion as EngineVersion | null;
    const engineVersionId = engineVersion ? engineVersion.id() : this.composer.fields.engineVersionId;

    // 调试日志
    console.log('EngineVersion onsubmit:', { engineVersion, engineVersionId });

    if (!engineVersionId) {
      app.alerts.show(
        { type: 'error' },
        app.translator.trans('laya-engine-version.forum.composer.validation.required')
      );
      return;
    }

    return original.call(this);
  });
}
